import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import servicePages from '../data/servicePages';

const Services = () => {
  const { language } = useLanguage();
  const { isDark } = useTheme();
  const es = language === 'es';
  return <section id="services" className={`py-20 px-4 m-0 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
    <div className="max-w-7xl mx-auto">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <p className="text-atlantis font-black tracking-widest text-sm mb-3">{es ? 'SOLUCIONES PARA NEGOCIOS' : 'BUSINESS SIGN SOLUTIONS'}</p>
        <h2 className={`text-4xl md:text-5xl font-black mb-5 ${isDark ? 'text-white' : 'text-saratoga'}`}>{es ? 'Más que channel letters' : 'More than channel letters'}</h2>
        <p className={`text-lg ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>{es ? 'Explora cada servicio y encuentra la opción correcta para tu local, vehículo o promoción.' : 'Explore each service and find the right option for your storefront, vehicle or promotion.'}</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {servicePages.map((service) => <Link key={service.slug} to={`/${service.slug}`} className={`group overflow-hidden rounded-2xl border shadow-lg hover:-translate-y-1 transition-transform ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
          <img src={service.image} alt="" className="h-44 w-full object-cover" loading="lazy" />
          <div className="p-5"><h3 className={`text-xl font-black mb-3 ${isDark ? 'text-white' : 'text-saratoga'}`}>{es ? service.esTitle : service.title}</h3><span className="inline-flex items-center gap-2 text-atlantis font-black">{es ? 'Ver servicio' : 'View service'} <FaArrowRight /></span></div>
        </Link>)}
      </div>
    </div>
  </section>;
};

export default Services;
